import React from "react";
import "./footer.css";

const Footer = () => (
    <footer>
        <i className="fa fa-github" aria-hidden="true" />
        Developed by
        <a href="https://github.com/maryamhdr/react-weather-app"> MaryamHeydarian</a>
    </footer>
);

export default Footer;